export default __webpack_public_path__ + "static/media/san.8f84dd04.svg";